import { Group } from '@visx/group';
import { QUALITY_BRUSH } from '../consts';

/** SVG path for resize handles (visx demo geometry; colocated — not a tunable theme token). */
const GRIP_PATH_D =
  'M -4.5 0.5 L 3.5 0.5 L 3.5 15.5 L -4.5 15.5 L -4.5 0.5 M -1.5 4 L -1.5 12 M 0.5 4 L 0.5 12';

/** Props shape matches @visx/brush `BrushHandleRenderProps` (not exported from the package root). */
export type BrushHandleProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  isBrushActive: boolean;
  className: string;
};

/**
 * Vertical “grip” handles for the horizontal range brush (visx demo style).
 * Offset matches visx docs: position is adjusted so the path sits on the selection edge.
 */
export function BrushHandle({ x, height, isBrushActive, className }: BrushHandleProps) {
  if (!isBrushActive) {
    return null;
  }

  return (
    <Group
      left={x + QUALITY_BRUSH.gripPathWidth / 2}
      top={(height - QUALITY_BRUSH.gripPathHeight) / 2}
    >
      <path
        className={className}
        fill={QUALITY_BRUSH.handleFill}
        d={GRIP_PATH_D}
        stroke={QUALITY_BRUSH.handleStroke}
        strokeWidth={1}
        style={{ cursor: 'ew-resize' }}
      />
    </Group>
  );
}
